// Define a constant array with the modalities
export const STACK_MODALITIES = ['CT', 'MR', 'XA'];

export const isSingleImageModality = modality => {
  return !STACK_MODALITIES.includes(modality);
};
